import { render, staticRenderFns } from "./ConfiguracionMapeos.vue?vue&type=template&id=1286a451&scoped=true&"
import script from "./ConfiguracionMapeos.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionMapeos.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionMapeos.vue?vue&type=style&index=0&id=1286a451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286a451",
  null
  
)

export default component.exports